import { useState, FC, useRef, MouseEvent } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import { ActionsDropdownButton } from "@/components/ActionsDropdown";
import { ReactComponent as PlusIcon } from "@/assets/icons/plus.svg";
import Button from "@/components/Button";
import TopicsCreationFormModal from "@/components/TopicsCreationFormModal";
import { Box } from "./Dropdown";
import useOnClickOutside from "@/hooks/useOnClickOutside";

const Holder = styled.div`
  position: relative;
  margin-left: auto;
`;

const StyledBox = styled(Box)`
  max-width: 125px;
  padding: 4px;
`;

interface CreationModalState {
  category: "script" | "thumb" | "title" | "type";
  isOpen: boolean;
  title: string;
}

interface Props {
  className?: string;
}

const TopicsCreationDropdown: FC<Props> = ({ className }) => {
  const [showDropdow, setShowDrodown] = useState(false);

  const [creationModalState, setCreationModalState] =
    useState<CreationModalState>({
      isOpen: false,
      title: "New Video type",
      category: "title",
    });

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowDrodown(false));

  return (
    <Holder className={className}>
      <Button
        color="action"
        small
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setShowDrodown((prev) => !prev);
        }}
      >
        <PlusIcon />
        New topic
      </Button>
      {showDropdow && (
        <StyledBox ref={ref}>
          <ActionsDropdownButton
            as="button"
            onClick={() => {
              setCreationModalState({
                isOpen: true,
                category: "script",
                title: "New script topic",
              });
              setShowDrodown(!showDropdow);
            }}
          >
            Script topic
          </ActionsDropdownButton>
          <ActionsDropdownButton
            as="button"
            onClick={() => {
              setCreationModalState({
                isOpen: true,
                category: "thumb",
                title: "New thumb topic",
              });
              setShowDrodown(!showDropdow);
            }}
          >
            Thumb topic
          </ActionsDropdownButton>
          <ActionsDropdownButton
            as="button"
            onClick={() => {
              setCreationModalState({
                isOpen: true,
                category: "title",
                title: "New title topic",
              });
              setShowDrodown(!showDropdow);
            }}
          >
            Title topic
          </ActionsDropdownButton>
          <ActionsDropdownButton
            as="button"
            onClick={() => {
              setCreationModalState({
                isOpen: true,
                category: "type",
                title: "New video type",
              });
              setShowDrodown(!showDropdow);
            }}
          >
            Video type
          </ActionsDropdownButton>
        </StyledBox>
      )}
      <AnimatePresence>
        {creationModalState.isOpen && (
          <TopicsCreationFormModal
            onClose={() =>
              setCreationModalState({
                isOpen: false,
                title: "New video type",
                category: "thumb",
              })
            }
            category={creationModalState.category}
            title={creationModalState.title}
          />
        )}
      </AnimatePresence>
    </Holder>
  );
};

export default TopicsCreationDropdown;
